interface Props {
  label: string;
  value: string | number;
  sub: string;
  colorClass: string;
  className?: string;
}
export function MetricCard({
  label,
  value,
  sub,
  colorClass,
  className
}: Props) {
  return <div className={['mc', className].filter(Boolean).join(' ')} data-id="element-427">
      <div className="ml" data-id="element-428">{label}</div>
      <div className={`mv ${colorClass}`} data-id="element-429">{value}</div>
      <div className="ms" data-id="element-430">{sub}</div>
    </div>;
}